import React from "react";

export const AutoDeliveryEnabledCell = ({ row, value }) => <>{value === null ? "" : value ? "Enabled" : "Not Enabled"}</>;
